class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        // if (elementToRender.parentElement) {
        //   document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        // }
        if (elementToRender.parentElement) {
  const insertTarget = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
  if (insertTarget) {
    insertTarget.before(elementToRender);
  } else {
    console.warn('insertBefore 対象が見つかりませんでした。代わりに末尾に挿入します');
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      container.appendChild(elementToRender);
    }
  }
}
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

static renderAdditionalElements(html) {
  const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

  mobileElementSelectors.forEach((selector) => {
    if (!html.querySelector(selector)) return;
    const elementInDom = document.querySelector(selector);
    if (elementInDom) {
      elementInDom.innerHTML = html.querySelector(selector).innerHTML;
    }
  });

  // 安全に menu-drawer とその bindEvents メソッドの存在をチェック
  const mobileFiltersForm = document.getElementById('FacetFiltersFormMobile');
  if (mobileFiltersForm) {
    const menuDrawer = mobileFiltersForm.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }
  // menu-drawer が存在しない場合には何もしない
}

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  //   if (event.srcElement.className == 'mobile-facets__checkbox') {
  //     const searchParams = this.createSearchParams(event.target.closest('form'));
  //     this.onSubmitForm(searchParams, event);
  //   } else {
  //     const forms = [];
  //     const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

  //     sortFilterForms.forEach((form) => {
  //       if (!isMobile) {
  //         if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
  //           const noJsElements = document.querySelectorAll('.no-js-list');
  //           noJsElements.forEach((el) => el.remove());
  //           forms.push(this.createSearchParams(form));
  //         }
  //       } else if (form.id === 'FacetFiltersFormMobile') {
  //         forms.push(this.createSearchParams(form));
  //       }
  //     });
  //     this.onSubmitForm(forms.join('&'), event);
  //   }
  // }
  onSubmitHandler(event) {
  event.preventDefault();

  const isSearchPage = window.location.pathname.startsWith('/search');
  const sortFilterForms = document.querySelectorAll('facet-filters-form form');

  if (event.srcElement.className === 'mobile-facets__checkbox') {
    const searchParams = this.createSearchParams(event.target.closest('form'));

    if (isSearchPage) {
      // 検索ページの場合、リロードで遷移
      window.location.href = `${window.location.pathname}?${searchParams}`;
    } else {
      // 通常通りAjaxで更新
      this.onSubmitForm(searchParams, event);
    }

    return;
  }

  const forms = [];
  const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

  sortFilterForms.forEach((form) => {
    if (!isMobile) {
      if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(form));
      }
    } else if (form.id === 'FacetFiltersFormMobile') {
      forms.push(this.createSearchParams(form));
    }
  });

  const searchParams = forms.join('&');

  if (isSearchPage) {
    // 検索ページはリロード
    window.location.href = `${window.location.pathname}?${searchParams}`;
  } else {
    // コレクションなどはAjax更新
    this.onSubmitForm(searchParams, event);
  }
}

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.initSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

     // 新しく追加：入力フィールドの値に合わせてスライダーを更新
    this.updateSliderPosition();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  
  // 絞り込み価格スライダーカスタマイズ
  initSlider() {
    // スライダー要素への参照を取得
    this.slider = this.querySelector('.price-slider');
    if (!this.slider) {
      console.warn('price-slider要素が見つかりません');
      return; // 早期リターン
    }
    
    // スライダー要素への参照を取得
    this.slider = this.querySelector('.price-slider');
    this.rail = this.querySelector('.price-slider__rail');
    this.range = this.querySelector('.price-slider__range');
    this.minHandle = this.querySelector('.price-slider__handle--min');
    this.maxHandle = this.querySelector('.price-slider__handle--max');
    
    // 必須要素のチェック
    if (!this.rail || !this.range || !this.minHandle || !this.maxHandle) {
      console.warn('スライダーの必須要素が見つかりません');
      return;
    }
    
    // 入力フィールドから実際の価格範囲を取得
    const inputs = this.querySelectorAll('input');
    this.minInput = inputs[0];
    this.maxInput = inputs[1];
    
    // min/maxの属性から実際の価格範囲を取得
    this.minValue = Number(this.minInput.getAttribute('min') || 0);
    this.maxValue = Number(this.maxInput.getAttribute('max'));
  
    // 現在選択されている値を取得
    const currentMinValue = this.minInput.value ? Number(this.minInput.value) : this.minValue;
    const currentMaxValue = this.maxInput.value ? Number(this.maxInput.value) : this.maxValue;
    
    // 初期位置を設定
    this.updateSliderPosition(currentMinValue, currentMaxValue);
    
    // スライダーのドラッグイベントを設定
    this.setupDragEvents();
  }
  
  updateSliderPosition(min, max) {
    // 要素が存在するか確認
    if (!this.minHandle || !this.maxHandle || !this.range || !this.slider) {
      console.warn('スライダー要素が見つかりません');
      return;
    }
  
  // 引数がない場合は入力フィールドから値を取得
  const minVal = min !== undefined ? min : (this.minInput.value ? Number(this.minInput.value) : this.minValue);
  const maxVal = max !== undefined ? max : (this.maxInput.value ? Number(this.maxInput.value) : this.maxValue);

  // 値が有効か確認
  if (isNaN(minVal) || isNaN(maxVal) || this.maxValue <= this.minValue) {
    console.warn('無効な価格範囲です');
    return;
  }
    
  // パーセンテージに変換
  const minPercent = ((minVal - this.minValue) / (this.maxValue - this.minValue)) * 100;
  const maxPercent = ((maxVal - this.minValue) / (this.maxValue - this.minValue)) * 100;
    
  // スライダーの位置を更新
  this.minHandle.style.left = `${minPercent}%`;
  this.maxHandle.style.left = `${maxPercent}%`;
  this.range.style.left = `${minPercent}%`;
  this.range.style.width = `${maxPercent - minPercent}%`;
    
  // 表示価格も更新
  this.updatePriceDisplay(minVal, maxVal);
}
  
  setupDragEvents() {
      // 必須要素のチェック
  if (!this.minHandle || !this.maxHandle) {
    console.warn('ハンドル要素が見つかりません');
    return;
  }
    // ドラッグ処理の実装
    // 最小値ハンドルのドラッグ
    this.minHandle.addEventListener('mousedown', this.startDragMin.bind(this));
    // 最大値ハンドルのドラッグ
    this.maxHandle.addEventListener('mousedown', this.startDragMax.bind(this));
    
    // タッチデバイスのサポート
    this.minHandle.addEventListener('touchstart', this.startDragMin.bind(this));
    this.maxHandle.addEventListener('touchstart', this.startDragMax.bind(this));
  }
  
  // 追加する新しいメソッド
  updatePriceDisplay(minVal, maxVal) {
    const minDisplay = this.querySelector('.price-display__min');
    const maxDisplay = this.querySelector('.price-display__max');
    
    if (minDisplay && maxDisplay) {
      // 日本円の場合のフォーマット
      minDisplay.textContent = `¥${minVal.toLocaleString()}`;
      maxDisplay.textContent = `¥${maxVal.toLocaleString()}`;
    }
  }

startDragMin(event) {
  event.preventDefault();
  
  // マウスイベントとタッチイベントの両方に対応
  const startX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
  const sliderRect = this.slider.getBoundingClientRect();
  const startPosition = parseFloat(this.minHandle.style.left) || 0;
  
  const onMove = (moveEvent) => {
    const currentX = moveEvent.type.includes('mouse') ? moveEvent.clientX : moveEvent.touches[0].clientX;
    const diffX = currentX - startX;
    const percent = (diffX / sliderRect.width) * 100;
    let newPosition = Math.max(0, Math.min(parseFloat(this.maxHandle.style.left) - 5, startPosition + percent));
    
    // スライダーの位置を更新
    this.minHandle.style.left = `${newPosition}%`;
    this.range.style.left = `${newPosition}%`;
    this.range.style.width = `${parseFloat(this.maxHandle.style.left) - newPosition}%`;
    
    // 入力フィールドの値を更新
    const newValue = Math.round(this.minValue + (newPosition / 100) * (this.maxValue - this.minValue));
    this.minInput.value = newValue;
    
    // 表示価格を更新
    if (typeof this.updatePriceDisplay === 'function') {
      this.updatePriceDisplay(newValue, this.maxInput.value ? Number(this.maxInput.value) : this.maxValue);
    }
  };
  
  const onEnd = () => {
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('mouseup', onEnd);
    document.removeEventListener('touchend', onEnd);
    
    // フォームを送信して結果を更新
    const form = this.closest('form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  };
  
  document.addEventListener('mousemove', onMove);
  document.addEventListener('touchmove', onMove);
  document.addEventListener('mouseup', onEnd);
  document.addEventListener('touchend', onEnd);
}

startDragMax(event) {
  event.preventDefault();
  
  // マウスイベントとタッチイベントの両方に対応
  const startX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
  const sliderRect = this.slider.getBoundingClientRect();
  const startPosition = parseFloat(this.maxHandle.style.left) || 100;
  
  const onMove = (moveEvent) => {
    const currentX = moveEvent.type.includes('mouse') ? moveEvent.clientX : moveEvent.touches[0].clientX;
    const diffX = currentX - startX;
    const percent = (diffX / sliderRect.width) * 100;
    let newPosition = Math.min(100, Math.max(parseFloat(this.minHandle.style.left) + 5, startPosition + percent));
    
    // スライダーの位置を更新
    this.maxHandle.style.left = `${newPosition}%`;
    this.range.style.width = `${newPosition - parseFloat(this.range.style.left)}%`;
    
    // 入力フィールドの値を更新
    const newValue = Math.round(this.minValue + (newPosition / 100) * (this.maxValue - this.minValue));
    this.maxInput.value = newValue;
    
    // 表示価格を更新
    if (typeof this.updatePriceDisplay === 'function') {
      this.updatePriceDisplay(this.minInput.value ? Number(this.minInput.value) : this.minValue, newValue);
    }
  };
  
  const onEnd = () => {
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('mouseup', onEnd);
    document.removeEventListener('touchend', onEnd);
    
    // フォームを送信して結果を更新
    const form = this.closest('form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  };
  
  document.addEventListener('mousemove', onMove);
  document.addEventListener('touchmove', onMove);
  document.addEventListener('mouseup', onEnd);
  document.addEventListener('touchend', onEnd);
}
}

customElements.define('price-range', PriceRange);

  // 検索結果ページ絞り込みタグ削除のカスタマイズ
// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
//   }


//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;

    facetLink.setAttribute('role', 'button');

    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

closeFilter(event) {
    const href = event.currentTarget.href;
    const isSearchPage = window.location.pathname.startsWith('/search');

    // 「すべて削除」ボタンを押したとき
    if (event.currentTarget.classList.contains('js-clear-filters')) {
      if (isSearchPage) {
        // 検索結果ページならカスタム遷移
        event.preventDefault();
        const urlParams = new URLSearchParams(window.location.search);
        const searchTerm = urlParams.get('q') || '';
        const newUrl = `/search?q=${encodeURIComponent(searchTerm)}&type=product`;
        window.location.href = newUrl;
      } else {
        // コレクションページは href 通りに遷移させる（デフォルト動作許可）
      }
      return;
    }

    // 通常のフィルター削除（バツボタン）
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (isSearchPage) {
      // 修正: 現在のURLから現在のクエリを維持しつつ、削除対象のフィルターのみ除去
      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(href);
      const targetParams = new URLSearchParams(targetUrl.search);
      
      // 検索クエリ(q)を維持
      const searchQuery = currentUrl.searchParams.get('q');
      if (searchQuery) {
        targetParams.set('q', searchQuery);
      }
      
      // type=productを維持
      if (!targetParams.has('type')) {
        targetParams.set('type', 'product');
      }
      
      window.location.href = `${window.location.pathname}?${targetParams.toString()}`;
    } else {
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);


(function() {
  // ドロワーの要素を選択
  const menuDrawer = document.querySelector('menu-drawer');
  const headerWrap = document.querySelector('.header-wrap, div.header-wrap');
  
  // ドロワーの状態を追跡するグローバル変数
  let isMainDrawerOpen = false;
  let isSubMenuOpen = false;
  
  if (menuDrawer && headerWrap) {
    
    // メインドロワーの開閉を追跡する関数
    function trackDrawerState() {
      // メインのdetails要素を取得
      const mainDetails = menuDrawer.querySelector('details');
      if (!mainDetails) return;
      
      // 開閉状態を監視するMutationObserver
      const mainObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            // detailsのopen属性が変更された
            isMainDrawerOpen = mainDetails.hasAttribute('open');
            
            if (isMainDrawerOpen) {
              // ドロワーが開いた - ヘッダーを非表示
              headerWrap.style.cssText = "z-index: -1 !important; position: relative !important; visibility: hidden !important;";
            } else {
              // ドロワーが閉じた - ヘッダーを表示
              setTimeout(function() {
                headerWrap.style.cssText = "";
              }, 300);
            }
          }
        });
      });
      
      // 属性変更を監視
      mainObserver.observe(mainDetails, { attributes: true });
      
      // サブメニューの状態を監視
      const submenus = menuDrawer.querySelectorAll('.mobile-facets__submenu');
      submenus.forEach(function(submenu) {
        const observer = new MutationObserver(function(mutations) {
          // サブメニューの表示/非表示を追跡
          isSubMenuOpen = Array.from(submenus).some(menu => 
            window.getComputedStyle(menu).display !== 'none');
          
          // サブメニューが表示中の場合は確実にヘッダーを非表示
          if (isMainDrawerOpen) {
            headerWrap.style.cssText = "z-index: -1 !important; position: relative !important; visibility: hidden !important;";
          }
        });
        
        observer.observe(submenu, { attributes: true, subtree: true });
      });
    }
    
    // サブメニューの戻るボタンのクリックイベントを追加
    function setupBackButtonHandlers() {
      const backButtons = menuDrawer.querySelectorAll('.mobile-facets__close-button');
      
      backButtons.forEach(button => {
        button.addEventListener('click', function(event) {
          
          // メインドロワーがまだ開いている場合はヘッダーを非表示のままにする
          if (isMainDrawerOpen) {
            headerWrap.style.cssText = "z-index: -1 !important; position: relative !important; visibility: hidden !important;";
          }
        });
      });
    }
    
    // メインの閉じるボタンのクリックイベントを追加
    function setupCloseButtonHandler() {
      // メインの閉じるボタン（×ボタン）を選択
      const closeButton = menuDrawer.querySelector('.mobile-facets__close, summary .mobile-facets__close--no-js');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          isMainDrawerOpen = false;
          
          // ヘッダーを表示（アニメーション後）
          setTimeout(function() {
            headerWrap.style.cssText = "";
          }, 300);
        });
      }
      
      // 適用ボタンのクリックも追跡
      const applyButtons = menuDrawer.querySelectorAll('.mobile-facets__footer .button--primary');
      applyButtons.forEach(button => {
        button.addEventListener('click', function() {
          isMainDrawerOpen = false;
          
          // ヘッダーを表示（アニメーション後）
          setTimeout(function() {
            headerWrap.style.cssText = "";
          }, 300);
        });
      });
    }
    
    // ドロワーの開くボタンのクリックハンドラ
    const openButton = document.querySelector('.mobile-facets__open-wrapper');
    if (openButton) {
      openButton.addEventListener('click', function() {
        isMainDrawerOpen = true;
        headerWrap.style.cssText = "z-index: -1 !important; position: relative !important; visibility: hidden !important;";
      });
    }
    
    // 初期化: すべてのイベントハンドラーを設定
    trackDrawerState();
    setupBackButtonHandlers();
    setupCloseButtonHandler();
    
    // ページ読み込み後にクリック可能な要素を再検出
    document.addEventListener('DOMContentLoaded', function() {
      // DOMが変更された場合にイベントハンドラーを再設定
      setupBackButtonHandlers();
      setupCloseButtonHandler();
    });
    
    // フィルター適用後に要素が変更される可能性があるため、MutationObserverを使用
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // 変更があった場合、ハンドラーを再設定
          setTimeout(function() {
            setupBackButtonHandlers();
            setupCloseButtonHandler();
          }, 100);
        }
      });
    });
    
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();



document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.startsWith('/search')) return;
  const drawerDetails = document.querySelector(
    'menu-drawer details.mobile-facets__disclosure'
  );
  if (!drawerDetails) return;
  
  // ─── 初回ロード判定 ───
  const params    = new URLSearchParams(window.location.search);
  const hasFilter = [...params.keys()].some(k => k.startsWith('filter.v.'));
  if (!hasFilter) sessionStorage.removeItem('filterDrawerOpen');
  
  const summary     = drawerDetails.querySelector('summary.mobile-facets__open-wrapper');
  const closeBtns   = drawerDetails.querySelectorAll('.mobile-facets__footer .button--primary');
  const closeIcon   = drawerDetails.querySelector('.mobile-facets__close--no-js');
  
  // 共通の「閉じる」処理をまとめておく
  const closeDrawer = () => {
    drawerDetails.removeAttribute('open');
    drawerDetails.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-mobile');
    sessionStorage.removeItem('filterDrawerOpen');
  };
  
  // 1) セッションにフラグが立っていれば自動オープン
  if (sessionStorage.getItem('filterDrawerOpen') === 'true') {
    drawerDetails.setAttribute('open', '');
    drawerDetails.classList.add('menu-opening');
    document.body.classList.add('overflow-hidden-mobile'); // これを追加
  }
  
  // 2) 「絞り込む」クリック → フラグを立てて開く
  summary.addEventListener('click', e => {
    if (e.target.closest('.mobile-facets__close--no-js')) {
      return;
    }
    e.preventDefault();
    drawerDetails.setAttribute('open', '');
    drawerDetails.classList.add('menu-opening');
    document.body.classList.add('overflow-hidden-mobile');
    sessionStorage.setItem('filterDrawerOpen', 'true');
  });
  
  // 3) 「商品を見る」クリック → 閉じる
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeDrawer);
  });
  
  // 4) ✕アイコンを押したときにも閉じる
  if (closeIcon) {
    closeIcon.addEventListener('click', e => {
      e.stopPropagation();
      closeDrawer();
    });
  }
  
  // 重要：ここでdrawerDetailsのclick処理は残しておらず、
  // ドキュメント全体のクリックイベントも削除しています
  
  // ★重要：既存のdetails要素の挙動をオーバーライド
  // ドロワー要素にnative動作を無効化するためのリスナーを追加
  drawerDetails.addEventListener('toggle', (e) => {
    // toggle イベントが標準の動作で発生した場合、
    // ユーザーが外側をクリックして閉じようとしたときにこれが発火します
    if (!drawerDetails.hasAttribute('open')) {
      // detailsが閉じようとしている場合、それを防止
      e.preventDefault();
      // 実際には閉じさせないため、再度開く
      setTimeout(() => {
        drawerDetails.setAttribute('open', '');
      }, 0);
    }
  });
  
}); // DOMContentLoadedリスナーの終了

/**
 * 検索ページ用に最低限必要な util.js 関数
 絞り込みタグの生成に関係
 */

// デバウンス関数 - 頻繁に実行される処理を制限するヘルパー関数
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// escape キーによるモーダル閉じるためのヘルパー関数
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  if (summaryElement) {
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
}

// アクセシビリティ - フォーカストラップ
function trapFocus(container, elementToFocus = container) {
  var focusableEls = container.querySelectorAll(
    'summary, a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
  );
  
  if (focusableEls.length === 0) return;
  
  var firstFocusableEl = focusableEls[0];
  var lastFocusableEl = focusableEls[focusableEls.length - 1];
  
  if (!elementToFocus.matches('input, select, textarea, button, summary')) {
    elementToFocus = firstFocusableEl || container;
  }
  
  elementToFocus.focus();
  
  container.addEventListener('keydown', function(e) {
    if (e.code !== 'Tab') return;
    
    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

// フォーカストラップ解除
function removeTrapFocus(container) {
  if (!container) return;
  container.removeEventListener('keydown', function(e) {
    if (e.code !== 'Tab') return;
  });
}